module.exports = __webpack_public_path__ + "static/7skillstechniquesba-847130a9119698f25daeccb9ae59678f.jpg";